import { render, staticRenderFns } from "./ShoppingWidget.vue?vue&type=template&id=65ce3e44&scoped=true&"
import script from "./ShoppingWidget.vue?vue&type=script&lang=js&"
export * from "./ShoppingWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingWidget.vue?vue&type=style&index=0&id=65ce3e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce3e44",
  null
  
)

export default component.exports